import { RouteRecordRaw } from 'vue-router'
import AuthLayout from '@/view/partials/AuthLayout.vue'

const authRoutes: RouteRecordRaw = {
  name: 'Auth',
  path: '/auth/',
  component: AuthLayout,
  children: [
    {
      name: 'Login',
      path: 'login',
      component: () => import('./login/LoginView.vue'),
      meta: {
        title: 'My Sentia | Login',
      },
    },
    {
      name: 'Callback',
      path: 'implicit/callback',
      component: () => import('./callback/CallbackView.vue'),
      meta: {
        title: 'My Sentia | Callback',
      },
    },
    {
      name: 'Logout',
      path: 'logout',
      component: () => import('./logout/LogoutView.vue'),
      meta: {
        title: 'My Sentia | Logout',
      },
    },
  ],
}

export { authRoutes }
